module.exports = __webpack_public_path__ + "static/lifetime-fitness-gold-membership-icon-235d5bf846ec45d316fd48bdd547a47f.svg";